var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H26.5C27.3284 0 28 0.671573 28 1.5C28 2.32843 27.3284 3 26.5 3H1.5C0.671572 3 0 2.32843 0 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 8.67157 0.671573 8 1.5 8H26.5C27.3284 8 28 8.67157 28 9.5C28 10.3284 27.3284 11 26.5 11H1.5C0.671572 11 0 10.3284 0 9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 16.6716 0.671573 16 1.5 16H26.5C27.3284 16 28 16.6716 28 17.5C28 18.3284 27.3284 19 26.5 19H1.5C0.671572 19 0 18.3284 0 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuIcon);
export default __webpack_public_path__ + "static/media/ManuIcon.45802ba551bec8a9cd0cb7693157c0d5.svg";
export { ForwardRef as ReactComponent };